export default {
  marketManBuyers: [],
  marketManBuyer: undefined,
};
